import React from 'react';
import { motion } from 'framer-motion';
// Imports removidos - não utilizados no layout simplificado

interface PricingSectionProps {
  onOpenModal: () => void;
}

const PricingSection: React.FC<PricingSectionProps> = ({ onOpenModal }) => {
  const handlePurchase = () => {
    // Abre o modal de checkout
    onOpenModal();
  };

  return (
    <section id="pricing" className="py-20" style={{ backgroundColor: '#F7F5EF' }}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Presenteie com o que realmente importa: tempo, fé e amor.
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Um presente que cresce junto com seu filho. E que pode transformar toda a rotina da sua família.
            </p>
          </motion.div>

          {/* Pricing Card - Layout simplificado como no exemplo */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="max-w-2xl mx-auto"
          >
            <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 p-8 lg:p-12 text-center">
              {/* Title */}
              <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                Meu Primeiro Jardim de Fé
              </h3>

              {/* Price */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                className="mb-6"
              >
                <div className="text-2xl text-gray-500 line-through mb-2">
                  De R$ 197
                </div>
                <div className="text-5xl lg:text-6xl font-bold text-gray-900">
                  R$ 37
                </div>
                <div className="text-lg text-gray-600">
                  à vista ou 5x de R$ 8,19
                </div>
                <div className="text-sm text-green-600 font-medium mt-2">
                  Pagamento único • Acesso vitalício
                </div>
              </motion.div>

              {/* Description */}
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                className="text-gray-700 text-lg leading-relaxed mb-8 max-w-lg mx-auto"
              >
                Um kit completo para cultivar fé, amor e virtude no coração do seu filho. 
                6 materiais prontos para usar, com práticas devocionais e emocionais para crianças e pais.
              </motion.p>

              {/* Benefit Tags */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.8 }}
                viewport={{ once: true }}
                className="flex flex-wrap justify-center gap-3 mb-8"
              >
                <span className="bg-yellow-200 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">6 Materiais</span>
                <span className="bg-yellow-200 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">PDF Completo</span>
                <span className="bg-yellow-200 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">4-13 anos</span>
                <span className="bg-yellow-200 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">Acesso Imediato</span>
                <span className="bg-yellow-200 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">Suporte</span>
                <span className="bg-yellow-200 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">Garantia 7 dias</span>
              </motion.div>

              {/* CTA Button */}
              <motion.button
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handlePurchase}
                className="bg-black text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-800 transition-colors duration-300 mb-4"
              >
                Quero plantar esse Jardim com meu filho(a)
              </motion.button>

            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default PricingSection;
